import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}order`;

export const createOrder = (product) =>{
    const token = localStorage.getItem('token');

    return axios.post(API_URL, product, {
    headers: {
        Authorization: `Bearer ${token}`, // Send token in Authorization header
    },
});}

export const getOrderByIdUser = () =>{
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/order/by-user-order`, {
    headers: {
        Authorization: `Bearer ${token}`, // Send token in Authorization header
        'Content-Type': 'application/json',  // Indicates the format of the request data
        'Accept': 'application/json',
    },
});}